export const environment = {
  production: false,
  envType: 'DEVELOPMENT',
  isFullOnline: true,
  caisseApiUrl: 'https://devgestion.quiditmiam.fr/api',
  title: 'Caisse Collective - Développement',
  buildDate: "2026-09-11T14:23:08",
  lastPipeline: "6540",
  version: "0.0.0",
  sentryDsn: '',
};
